export default __webpack_public_path__ + "static/media/Login PC.3cc115ec.png";